import React from "react";
import { Row } from "@tanstack/react-table";
import { MEStore } from "features/MappingEditor/MappingEditorStore";
import { productSearchStore } from "features/AdvancedProductSearch/ProductSearchStore";

const useKeyPressed = () => {
  const handleKeyDown = (key: string, type: string) => {
    if (productSearchStore.isOpened) {
      MEStore.setKeyPressed(null);
      return;
    }
    if (key === "CtrlA") {
      onPressedCtrlA();
    } else if (key === "ShiftDown") {
      onPressedShiftDown();
      MEStore.setLastShiftSelectKey("ShiftDown");
    } else if (key === "ShiftUp") {
      onPressedShiftUp();
      MEStore.setLastShiftSelectKey("ShiftUp");
    } else if (key === "Escape") {
      MEStore.setSelectedRows([]);
      MEStore.setSelectAllChecked(false);
    } else {
      type === "keydown"
        ? MEStore.setKeyPressed(key)
        : MEStore.setKeyPressed(null);
    }
    if (type === "keydown" && !["ShiftDown", "ShiftUp"].includes(key)) {
      MEStore.setLastShiftSelectKey(undefined);
    }
  };

  const onPressedShift = (row_index: number) => {
    let arrayRange: string[];
    if (row_index > Number(MEStore.selectedStartIndex)) {
      arrayRange = Array.from(
        {
          length: Number(row_index) - Number(MEStore.selectedStartIndex) + 1,
        },
        (_, i) => String(i + Number(MEStore.selectedStartIndex))
      );
    } else {
      arrayRange = Array.from(
        {
          length: Number(MEStore.selectedStartIndex) - Number(row_index) + 1,
        },
        (_, i) => String(i + Number(row_index))
      );
    }
    const timeout = setTimeout(() => {
      MEStore.addToSelectedRows(arrayRange);
      clearTimeout(timeout);
    }, 200);
  };

  const onPressedCtrlA = () => {
    MEStore.setSelectAllChecked(true);
  };

  const onPressedShiftDown = () => {
    if (MEStore.selectedStartIndex === null) return;
    //  Checking last pressed key to reverse last checked item on change direction
    const offset = MEStore.lastShiftSelectKey === "ShiftUp" ? 0 : 1;
    let nextIndex = Number(MEStore.selectedStartIndex) + offset;

    if (MEStore.selectedRowIndexes.includes(String(nextIndex))) {
      MEStore.removeFromSelectedRows(String(nextIndex));
      MEStore.setSelectedStartIndex(nextIndex);
    } else if (nextIndex) {
      MEStore.addToSelectedRows([String(nextIndex)]);
      MEStore.setSelectedStartIndex(nextIndex);
    }
  };

  const onPressedShiftUp = () => {
    if (MEStore.selectedStartIndex === null) return;
    const offset = MEStore.lastShiftSelectKey === "ShiftDown" ? 0 : 1;
    let prevIndex = Number(MEStore.selectedStartIndex) - offset;

    if (MEStore.selectedRowIndexes.includes(String(prevIndex))) {
      MEStore.removeFromSelectedRows(String(prevIndex));
      MEStore.setSelectedStartIndex(prevIndex);
    } else if (prevIndex > -1) {
      MEStore.addToSelectedRows([String(prevIndex)]);
      MEStore.setSelectedStartIndex(prevIndex);
    }
  };

  const handleMouseDragged = (row: Row<unknown>, direction: string) => {
    if (
      MEStore.lastDraggedObject.index !== row.index ||
      (MEStore.lastDraggedObject.index < row.index &&
        MEStore.lastDraggedObject.direction !== direction)
    ) {
      if (MEStore.selectedRowIndexes.includes(String(row.index))) {
        MEStore.removeFromSelectedRows(String(MEStore.lastDraggedObject.index));
        MEStore.removeFromSelectedRows(String(row.index));
      } else {
        MEStore.selectedRowIndexes.slice(-1)[0] !== String(row.index) &&
          MEStore.addToSelectedRows([String(row.index)]);
      }
      MEStore.setLastDraggedObject({
        index: row.index,
        direction: direction,
      });
    }
  };

  return {
    onPressedShift,
    handleKeyDown,
    handleMouseDragged,
  };
};

export default useKeyPressed;
